import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  spinner;
  background;
  constructor() {}

  //숨기기
  hide() {
    this.spinner.remove();
    this.background.remove();
  }

  //보이기
  show() {
    this.squareSpinner();
  }

  //1. 네모 동글 스피너
  squareSpinner() {
    // 스피너 배경 생성
    this.background = document.createElement('div');
    const background = this.background;
    background.style.width = '100vw';
    background.style.height = '100vh';
    background.style.position = 'absolute';
    background.style.top = '0';
    background.style.left = '0';
    background.style.zIndex = '1010';
    background.style.backgroundColor = 'rgba(0,0,0,0.3)';

    // 스피너 요소 생성
    this.spinner = document.createElement('div');
    const spinner = this.spinner;
    spinner.style.width = '50px';
    spinner.style.height = '50px';
    //색지정
    spinner.style.backgroundColor = '#333';
    spinner.style.position = 'absolute';
    spinner.style.top = '30%';
    spinner.style.left = '50%';
    spinner.style.transform = 'translate(-50%, -50%)';

    // 스피너 요소를 body에 추가
    document.body.appendChild(background);
    background.appendChild(spinner);

    let rotation = 0;
    let borderRadius = 50;
    let increasing = true;

    function update() {
      rotation += 1; // 회전 속도 조절
      spinner.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;

      if (increasing) {
        borderRadius += 1;
        if (borderRadius >= 50) {
          increasing = false;
        }
      } else {
        borderRadius -= 1;
        if (borderRadius <= 0) {
          increasing = true;
        }
      }

      spinner.style.borderRadius = `${borderRadius}%`;

      requestAnimationFrame(update);
    }
    update(); // 애니메이션 시작
  }

  //2. 동그라미 스피너
  circleSpinner() {
    // 스피너 배경 생성
    this.background = document.createElement('div');
    const background = this.background;
    background.style.width = '100vw';
    background.style.height = '100vh';
    background.style.position = 'absolute';
    background.style.top = '0';
    background.style.left = '0';
    background.style.zIndex = '1010';
    background.style.backgroundColor = 'rgba(0,0,0,0.3)';

    this.spinner = document.createElement('div');
    const spinner = this.spinner;
    spinner.style.width = '50px';
    spinner.style.height = '50px';
    spinner.style.position = 'absolute';
    spinner.style.top = '30%';
    spinner.style.left = '50%';
    spinner.style.transform = 'translate(-50%, -50%)';
    spinner.style.borderRadius = '50%';
    spinner.style.border = '3px solid #333';
    spinner.style.borderTop = '3px solid transparent';
    spinner.style.borderBottom = '3px solid transparent';

    // 스피너 요소를 body에 추가
    document.body.appendChild(background);
    background.appendChild(spinner);

    let rotation = 0;

    function update() {
      rotation += 5; // 회전 속도 조절
      spinner.style.transform = `rotate(${rotation}deg)`;

      requestAnimationFrame(update);
    }

    update(); // 애니메이션 시작
  }

  //3. 점점점 스피너
  dotSpinner() {
    // 스피너 배경 생성
    this.background = document.createElement('div');
    const background = this.background;
    background.style.width = '100vw';
    background.style.height = '100vh';
    background.style.position = 'absolute';
    background.style.top = '0';
    background.style.left = '0';
    background.style.zIndex = '1010';
    background.style.backgroundColor = 'rgba(0,0,0,0.3)';

    this.spinner = document.createElement('div');
    const spinner = this.spinner;
    spinner.style.width = '70px';
    spinner.style.height = '100px';
    spinner.style.position = 'absolute';
    spinner.style.top = '30%';
    spinner.style.left = '50%';
    spinner.style.transform = 'translate(-50%, -50%)';
    spinner.style.display = 'flex';
    spinner.style.justifyContent = 'space-between';
    spinner.style.alignItems = 'center';

    const delays = [0, 0.2, 0.4]; // 각 childDiv의 애니메이션 시작 지연 시간

    for (let i = 0; i < 3; i++) {
      const childDiv = document.createElement('div');
      childDiv.style.width = '12px';
      childDiv.style.height = '12px';
      childDiv.style.borderRadius = '50%';
      childDiv.style.backgroundColor = '#333';
      spinner.appendChild(childDiv);

      this.animatePulse(childDiv, delays[i]);
    }

    document.body.appendChild(background);
    background.appendChild(spinner);
  }

  animatePulse(element?: HTMLElement, delay?: number) {
    const animationDuration = 900; // 애니메이션 지속 시간 (밀리초)
    const fadeInStart = 0.5; // opacity가 시작되는 비율
    const fadeOutStart = 0.9; // opacity가 사라지기 시작되는 비율
    const initialScale = 0.5; // 초기 크기 비율
    const peakScale = 1.2; // 최대 크기 비율

    function runAnimation(isInitial: boolean) {
      const currentScale = isInitial ? initialScale : peakScale;
      const currentOpacity = isInitial ? 0 : 1;

      element.style.transition = `transform ${animationDuration}ms, opacity ${animationDuration}ms`;
      element.style.transitionTimingFunction = 'ease-in-out';

      element.style.opacity = String(currentOpacity);
      element.style.transform = `scale(${currentScale})`;

      setTimeout(() => {
        const nextScale = isInitial ? peakScale : initialScale;
        const nextOpacity = isInitial ? 1 : 0;

        element.style.opacity = String(nextOpacity);
        element.style.transform = `scale(${nextScale})`;

        setTimeout(() => {
          runAnimation(!isInitial);
        }, animationDuration * (isInitial ? fadeInStart : fadeOutStart));
      }, delay * 1000);
    }

    runAnimation(true);
  }

  //4. 막대 스피너1
  barLoader() {
    // 스피너 배경 생성
    this.background = document.createElement('div');
    const background = this.background;
    background.style.width = '100vw';
    background.style.height = '100vh';
    background.style.position = 'absolute';
    background.style.top = '0';
    background.style.left = '0';
    background.style.zIndex = '1010';
    background.style.backgroundColor = 'rgba(0,0,0,0.3)';

    this.spinner = document.createElement('div');
    const spinner = this.spinner;
    spinner.style.width = '60px';
    spinner.style.height = '200px';
    spinner.style.display = 'flex';
    spinner.style.justifyContent = 'space-between';
    spinner.style.alignItems = 'center';
    spinner.style.position = 'absolute';
    spinner.style.top = '30%';
    spinner.style.left = '50%';
    spinner.style.transform = 'translate(-50%, -50%)';

    const maxBarHeight = 50; // 최대 높이 (픽셀)
    const minBarHeight = 20; // 최소 높이 (픽셀)
    const animationDuration = 300; // 애니메이션 지속 시간 (밀리초)
    const interval = 1000; // 각 bar의 애니메이션 간격 (밀리초)

    const bars: HTMLElement[] = [];

    for (let i = 0; i < 3; i++) {
      const bar = document.createElement('div');
      bar.style.width = '13px';
      bar.style.height = `${minBarHeight}px`; // 초기 높이를 최소 높이로 설정
      bar.style.backgroundColor = '#333';
      bar.style.transition = `height ${animationDuration}ms ease`; // transition 추가

      document.body.appendChild(background);
      background.appendChild(spinner);
      spinner.appendChild(bar);
      bars.push(bar);
    }

    document.body.appendChild(spinner);

    this.animateBars(bars, maxBarHeight, minBarHeight, animationDuration, interval, 0);
  }

  animateBars(bars: HTMLElement[], endHeight: number, startHeight: number, duration: number, interval: number, currentIndex: number) {
    if (currentIndex >= bars.length) {
      currentIndex = 0;
    }

    const currentBar = bars[currentIndex];
    currentBar.style.height = `${endHeight}px`; // 높이 설정

    setTimeout(() => {
      currentBar.style.height = `${startHeight}px`; // 초기 높이로 되돌림
      setTimeout(() => {
        this.animateBars(bars, endHeight, startHeight, duration, interval, currentIndex + 1); // 다음 막대 움직임
      }, duration); // 지정된 시간 후에 다음 막대 애니메이션 시작
    }, duration); // 애니메이션 종료 후 지정된 시간 후에 다음 막대 애니메이션 시작
  }

  //막대 스피너2
  barLoader2() {
    // 스피너 배경 생성
    this.background = document.createElement('div');
    const background = this.background;
    background.style.width = '100vw';
    background.style.height = '100vh';
    background.style.position = 'absolute';
    background.style.top = '0';
    background.style.left = '0';
    background.style.zIndex = '1010';
    background.style.backgroundColor = 'rgba(0,0,0,0.3)';

    this.spinner = document.createElement('div');
    const spinner = this.spinner;
    spinner.style.width = '80px';
    spinner.style.height = '200px';
    spinner.style.display = 'flex';
    spinner.style.justifyContent = 'space-between';
    spinner.style.alignItems = 'center';
    spinner.style.position = 'absolute';
    spinner.style.top = '30%';
    spinner.style.left = '50%';
    spinner.style.transform = 'translate(-50%, -50%)';

    const maxBarHeight = 50; // 최대 높이 (픽셀)
    const animationDuration = 1000; // 애니메이션 지속 시간 (밀리초)
    const interval = 1000; // 각 bar의 애니메이션 간격 (밀리초)

    for (let i = 0; i < 3; i++) {
      const bar = document.createElement('div');
      bar.style.width = '15px';
      bar.style.height = '0'; // 초기 높이를 0으로 설정
      bar.style.backgroundColor = '#333';
      bar.style.transition = `height ${animationDuration}ms ease`; // transition 추가

      spinner.appendChild(bar);

      setTimeout(() => {
        this.animateBar(bar, maxBarHeight, animationDuration);
      }, interval * i); // 순차적인 지연을 주어 순서대로 애니메이션 시작
    }

    document.body.appendChild(background);
    background.appendChild(spinner);
  }

  animateBar(bar: HTMLElement, endHeight: number, duration: number) {
    bar.style.height = `${endHeight}px`; // 높이 설정
    setTimeout(() => {
      bar.style.height = '0'; // 초기 높이로 되돌림
      setTimeout(() => {
        this.animateBar(bar, endHeight, duration); // 반복 애니메이션
      }, duration); // 지정된 시간 후에 다시 애니메이션 시작
    }, duration); // 애니메이션 종료 후 지정된 시간 후에 다시 시작
  }
}
